const ONLY_WHITESPACE_REGEX = /^\s*$/
const LEADING_WHITESPACE_REGEX = /^\s*/
const TRAILING_WHITESPACE_REGEX = /\s*$/

/**
 * For text that has leading and ending space. We don't want to
 * convert it to `* strong *. Instead, we need it to be ` *strong* `
 */
export const baseMarkPattern = function baseMarkPattern (text, token) {
  if (ONLY_WHITESPACE_REGEX.test(text)) {
    /**
     * If it's a string with only whitespaces, wiki renderer
     * will behave incorrect if we apply format on it
     */
    return text
  }
  return text.replace(LEADING_WHITESPACE_REGEX, '$&'.concat(token)).replace(TRAILING_WHITESPACE_REGEX, ''.concat(token, '$&'))
}
